import { render, staticRenderFns } from "./DebitCardRejectNotificationModal.vue?vue&type=template&id=70f941b1&scoped=true"
import script from "./DebitCardRejectNotificationModal.vue?vue&type=script&lang=js"
export * from "./DebitCardRejectNotificationModal.vue?vue&type=script&lang=js"
import style0 from "./DebitCardRejectNotificationModal.vue?vue&type=style&index=0&id=70f941b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f941b1",
  null
  
)

export default component.exports